module.exports = __webpack_public_path__ + "static/media/img_discover-model.3e4c7947.png";